var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAutonomous)?_c('success-autonomous'):_c('success-company')
}
var staticRenderFns = []

export { render, staticRenderFns }